<template>
  <b-row>
    <b-col cols="12">
      <b-table
        id="news-table"
        responsive="sm"
        hover
        :items="news"
        :fields="fields"
        stacked="md"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        sort-icon-left
        :busy="isLoading"
        :perPage="perPage"
        :currentPage="currentPage"
        show-empty
        empty-text="Currently there are no news articles."
      >
        <template v-slot:cell(title)="row">
          <a href="#" @click.prevent="row.toggleDetails">{{ row.item.title }}</a>
        </template>
        <template v-slot:cell(type)="{ item }">{{ reportType[item.type] }}</template>
        <template v-slot:cell(status)="{ item }">
          <b-badge :variant="showStatus(item.status).variant">{{ showStatus(item.status).response }}</b-badge>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner small class="align-middle mr-2"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template v-slot:cell(actions)="row">
          <b-button
            v-if="row.detailsShowing"
            size="sm"
            @click="row.toggleDetails"
            variant="primary"
          >
            <i class="fas fa-eye-slash"></i>
            Hide details
          </b-button>
          <b-button v-else size="sm" @click="row.toggleDetails" variant="outline-primary">
            <i class="fas fa-eye"></i>
            Show details
          </b-button>
        </template>

        <template v-slot:empty="scope">
          <b-alert variant="warning" show>{{ scope.emptyText }}</b-alert>
        </template>
        <template v-slot:row-details="{ item }">
          <b-card>
            <b-form-group label="Description" label-cols-lg="3" label-cols-xl="2" label-align-lg="right">
              <div style="padding:0.425rem" v-html="item.short"></div>
            </b-form-group>
            <b-form-group
              label="Type"
              label-cols-lg="3"
              label-cols-xl="2"
              label-align-lg="right"
            >
              <div style="padding:0.425rem" v-if="item.article_type">{{ article_types[item.article_type] }}</div>
            </b-form-group>
            <b-form-group
              label="Keywords"
              label-cols-lg="3"
              label-cols-xl="2"
              label-align-lg="right"
            >
              <div style="padding:0.425rem">{{ item.keywords}}</div>
            </b-form-group>
            <b-form-group label="URL" label-cols-lg="3" label-cols-xl="2" label-align-lg="right">
              <a v-if="item.url" :href="item.url" target="_blank" class="btn btn-link">
                <b-icon icon="box-arrow-up-right" class="mr-1"></b-icon>
                {{ item.url }}
              </a>
            </b-form-group>
            <b-form-group label="Actions" label-cols-lg="3" label-cols-xl="2" label-align-lg="right">
              <b-button
                :to="{name:'edit_news',params:{article_id:item.id}}"
                variant="outline-primary"
                class="mr-2"
                size="sm"
              >
                <b-icon icon="pencil-square" class="mr-1"></b-icon>Edit
              </b-button>
              <b-button variant="danger" size="sm" @click.prevent="destroy(item)">
                <b-icon icon="trash" class="mr-1"></b-icon>Delete
              </b-button>
            </b-form-group>
          </b-card>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-number
        last-number
        align="center"
        aria-controls="projects-table"
      ></b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      sortBy: "created_at",
      stackedBr: "md",
      sortDesc: true,
      isLoading: true,
      currentPage: 1,
      perPage: 20,
      fields: [
        { key: "title", label: "Title", sortable: true },
        { key: "status", label: "Status", sortable: false },
        {
          key: "created_at",
          label: "Date",
          sortable: true,
          thStyle: { width: "190px" }
        },
        { key: "actions", label: "Details", thStyle: { width: "160px" } }
      ]
    };
  },
  created() {
    this.getAllNews()
      .then()
      .catch(err => {
        console.log(err);
      })
      .then(() => {
        this.isLoading = false;
      });
    const crumbs = [
      {
        html: "<i class='fas fa-home'></i>",
        to: { name: "home" }
      },
      {
        text: this.project_title,
        to: { name: "project" }
      },
      {
        text: "News",
        to: { name: "news" },
        active: true
      }
    ];
    this.$store.commit("setBreadcrumbs", crumbs);
  },
  computed: {
    ...mapGetters({
      project_title: "project/title",
      news: "news/all",
      article_types: "news/article_types",
    }),
    rows: function() {
      return this.news.length;
    },
    articleType: function(type){
      console.log(this.article_types);
      if(!this.article_types) return null;
      return this.article_types.map(function(key,value) {
       if(key == type) {
        return value;
       }
      });
    }
  },
  methods: {
    ...mapActions({
      getAllNews: "news/fetchNews",
      deleteArticle: "news/deleteArticle"
    }),
    destroy(article) {
      var response = confirm("Do you want to delete this article?");
      if (response) {
        this.deleteArticle(article.id)
          .then(res => {
            this.makeToast(
              "success",
              "Article deleted!",
              "Article " + article.title + " has been deleted."
            );
          })
          .catch(err => console.log(err));
      }
    }
  }
};
</script>

<style>
</style>